export default "__VITE_ASSET__CNUlHn3g__"